/** ***************** 
  @purpose : Used For Regex
  @Parameter : {}
  @Author : INIC
  ***************** */

export const InputValidator = {
  phoneRegExp: /([+]?\d{1,2}[.-\s]?)?(\d{3}[.-]?){2}\d{4}/,
  passwordRegExp: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
  emailRegExp:
    /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  otpRegExp: /[0-9]{6,6}$/,
  alphaOnlyRegx: /^[^\d]+$/,
  letter_space: /^[A-Za-z\s]+$/,
  mrn_numebr: /^[A-Za-z0-9]+$/,
};

/** ***************** 
  @purpose : Used For Default language for whole UNiversal Admin
  @Parameter : {}
  @Author : INIC
  ***************** */
export const DEFAULT_LANGUAGE_CODE = "en";
export const DEFAULT_LANGUAGE_NAME = "English";
export const DEFAULT_DATE_FORMAT = "YYYY-MM-DD";
export const sinusDepthOptions = Array.from({ length: 201 }, (_, i) => ({
  value: i.toString(),
  label: `${i} cm`,
}));
export const startPointOptions = [
  { label: "01.00", value: "1" },
  { label: "02.00", value: "2" },
  { label: "03.00", value: "3" },
  { label: "04.00", value: "4" },
  { label: "05.00", value: "5" },
  { label: "06.00", value: "6" },
  { label: "07.00", value: "7" },
  { label: "08.00", value: "8" },
  { label: "09.00", value: "9" },
  { label: "10.00", value: "10" },
  { label: "11.00", value: "11" },
  { label: "12.00", value: "12" },
];
export const endPointOptions = [
  { label: "01.00", value: "1" },
  { label: "02.00", value: "2" },
  { label: "03.00", value: "3" },
  { label: "04.00", value: "4" },
  { label: "05.00", value: "5" },
  { label: "06.00", value: "6" },
  { label: "07.00", value: "7" },
  { label: "08.00", value: "8" },
  { label: "09.00", value: "9" },
  { label: "10.00", value: "10" },
  { label: "11.00", value: "11" },
  { label: "12.00", value: "12" },
];
export const depthOptions = [
  { label: "0.1 cm", value: "0.1" },
  { label: "0.2 cm", value: "0.2" },
  { label: "0.3 cm", value: "0.3" },
  { label: "0.4 cm", value: "0.4" },
  { label: "0.5 cm", value: "0.5" },
  { label: "0.6 cm", value: "0.6" },
  { label: "0.7 cm", value: "0.7" },
  { label: "0.8 cm", value: "0.8" },
  { label: "0.9 cm", value: "0.9" },
  { label: "1.0 cm", value: "1.0" },
];
export const staticPoints = [
  { id: "1", cx: 367, cy: 42 }, // 1 no
  { id: "2", cx: 452, cy: 127 }, // 2 no
  { id: "3", cx: 487, cy: 249 }, // 3 no
  { id: "4", cx: 452, cy: 369 }, // 4 no
  { id: "5", cx: 367, cy: 453 }, // 5 no
  { id: "6", cx: 247, cy: 484 }, // 6 no
  { id: "7", cx: 131, cy: 453 }, // 7 no
  { id: "8", cx: 42, cy: 369 }, // 8 no
  { id: "9", cx: 10, cy: 247 }, // 9 no
  { id: "10", cx: 42, cy: 127 }, // 10 no
  { id: "11", cx: 131, cy: 42 }, // 11 no
  { id: "12", cx: 249, cy: 10 }, // 12 no
];

export const MAX_FILE_SIZE = 2 * 1024 * 1024;
export const MIN_IMAGE_COUNT = 1;
export const MAX_IMAGE_COUNT = 4;
export const QUESTION_TYPES = [
  { _id: "1", select: "Single Select", slug: "Single Select" },
  { _id: "2", select: "Multi Select", slug: "Multi Select" },
];
export const WoundStatusOption = [
  { label: "Active ", value: "ACTIVE" },
  { label: "Healed ", value: "HEALED" },
  { label: "Re-Active", value: "REACTIVE" },
  { label: "Needs Review", value: "NEEDS_REVIEW" },
];

export const woundTypeOption = [
  { label: "Anatomic Location", value: "anatomic_location" },
  { label: "Etiology", value: "etiology" },
  { label: "App User", value: "app_user" },
  { label: "Patient", value: "patient" },
];
